"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var PartnerPromoCodeTemplateEditor = /** @class */ (function (_super) {
    __extends(PartnerPromoCodeTemplateEditor, _super);
    function PartnerPromoCodeTemplateEditor(props) {
        return _super.call(this, props) || this;
    }
    PartnerPromoCodeTemplateEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data,
                avail_promocode_templates: []
            });
        });
        this.SID_PB = this.props.promoForBrandsList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_promocode_templates: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    promocode_template_id: _item.promocode_template_id,
                    promocode_template_title: _item.promocode_template_title,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    avail_promocode_templates: [],
                    avail_brands: [],
                    max_promo_count: _item.max_promocodes_count,
                    description: _item.description
                }, function () {
                    _this.loadOffersAvail();
                });
            }
        }
        else {
            this.setState({
                promocode_template_id: 0,
                promocode_template_title: "",
                brand_id: 0,
                brand_title: "",
                avail_promocode_templates: [],
                avail_brands: [],
                max_promo_count: 0,
                description: ""
            }, function () {
                _this.loadOffersAvail();
            });
        }
        this.doReSetRules();
    };
    PartnerPromoCodeTemplateEditor.prototype.loadOffersAvail = function () {
        this.props.brandsList.LoadData(this.props.rootRecord.key);
    };
    PartnerPromoCodeTemplateEditor.prototype.componentWillUnmount = function () {
        this.props.brandsList.UnSubscribe(this.SID_AB);
        this.props.promoForBrandsList.UnSubscribe(this.SID_PB);
    };
    PartnerPromoCodeTemplateEditor.prototype.doReSetRules = function () {
        this.setState({
            promocode_template_rules: { isError: false },
            brand_rules: { isError: false },
            max_promo_count_rules: { isError: false }
        });
    };
    PartnerPromoCodeTemplateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.promocode_template_id <= 0) || (this.state.promocode_template_title.length === 0)) {
            this.setState({ promocode_template_rules: { isError: true, errorMessage: "Шаблон промокода не выбран!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Бренд не выбран!" } });
            return false;
        }
        if ((!this.state.max_promo_count) || (this.state.max_promo_count <= 0)) {
            this.setState({ max_promo_count_rules: { isError: true, errorMessage: "Макс кол-во не заполнено!" } });
            return false;
        }
        return true;
    };
    PartnerPromoCodeTemplateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                // promo_code_template_id: this.state.promocode_template_id,
                max_promocodes_count: this.state.max_promo_count,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон промокода партнера изменен!");
            });
        }
    };
    PartnerPromoCodeTemplateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                promo_code_template_id: this.state.promocode_template_id,
                usr_partner_id: this.props.rootRecord.key,
                max_promo_count: this.state.max_promo_count,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон промокода партнера добавлен!");
            });
        }
    };
    PartnerPromoCodeTemplateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnerPromoCodeTemplateEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый шаблон промокода партнера";
        }
        else {
            return "Изменить шаблон промокода партнера";
        }
    };
    PartnerPromoCodeTemplateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 370 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    }, function () {
                        _this.props.promoForBrandsList.LoadData(_this.state.brand_id);
                    });
                }, items: this.state.avail_brands, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Шаблон промокода:", placeholder: "Выберите шаблон промокода" }, value: { key: this.state.promocode_template_id, value: this.state.promocode_template_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        promocode_template_id: newVal.key,
                        promocode_template_title: newVal.value,
                        promocode_template_rules: { isError: false }
                    });
                }, items: this.state.avail_promocode_templates, required: true, rules: this.state.promocode_template_rules, disabled: this.props.record != null }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Макс промокодов:", placeholder: "Введите максимальное кол-во промокодов доступных для создания" }, values: { max: 999, min: 1, value: this.state.max_promo_count }, onValueChanged: function (newVal) {
                    _this.setState({
                        max_promo_count: newVal,
                        max_promo_count_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.max_promo_count_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PartnerPromoCodeTemplateEditor;
}(React.Component));
exports.default = PartnerPromoCodeTemplateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/promo_codes_templates/PartnerPromoCodeTemplateEditor.tsx
// module id = 2444
// module chunks = 0